import { ReactComponent as arrowDown } from './asset/arrow-down.svg';
import { ReactComponent as arrowUp } from './asset/arrow-up.svg';
import { ReactComponent as cake } from './asset/cake.svg';
import { ReactComponent as cash } from './asset/cash.svg';
import { ReactComponent as check } from './asset/check.svg';
import { ReactComponent as close } from './asset/close.svg';
import { ReactComponent as date } from './asset/date.svg';
import { ReactComponent as doubleAnglesLeft } from './asset/double-angles-left.svg';
import { ReactComponent as fire } from './asset/fire.svg';
import { ReactComponent as gripHorizontal } from './asset/grip-horizontal.svg';
import { ReactComponent as gripVertical } from './asset/grip-vertical.svg';
import { ReactComponent as kanban } from './asset/kanban.svg';
import { ReactComponent as lastTime } from './asset/last-time.svg';
import { ReactComponent as list } from './asset/list.svg';
import { ReactComponent as megaboard } from './asset/megaboard.svg';
import { ReactComponent as more } from './asset/more.svg';
import { ReactComponent as plus } from './asset/plus.svg';
import { ReactComponent as progress } from './asset/progress.svg';
import { ReactComponent as snoozeSleep } from './asset/snooze-sleep.svg';
import { ReactComponent as snooze } from './asset/snooze.svg';
import { ReactComponent as today } from './asset/today.svg';
import { ReactComponent as trash } from './asset/trash.svg';

export const MonoIcon = {
  arrowDown,
  arrowUp,
  cake,
  cash,
  check,
  close,
  date,
  doubleAnglesLeft,
  fire,
  gripHorizontal,
  gripVertical,
  kanban,
  lastTime,
  list,
  megaboard,
  more,
  plus,
  progress,
  snooze,
  snoozeSleep,
  today,
  trash,
};
